module.exports = __webpack_public_path__ + "img/logo.fcf40577.png";